import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';

function Pyns(props) {
  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  return (
    <div className="container">
      <div className="title-section">Pyns</div>
      <div className="row">
        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Pyns Peace Hill</p>
              </div>
              <div className="card-action">
                <Link to="pynsPeaceHill">Pyns Peace Hill</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Safety Zones Peace Hill</p>
              </div>
              <div className="card-action">
                <Link to="safetyPeaceHill">Safety Zones Peace Hill</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Imports Pyns by company</p>
              </div>
              <div className="card-action">
                <Link to="importPynsByCompany">Imports Pyns</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Remove PlaceSearch by company</p>
              </div>
              <div className="card-action">
                <Link to="removePlaceSearchCompany">Remove PlaceSearch</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Remove Pyns Imported by company</p>
              </div>
              <div className="card-action">
                <Link to="removePynsImportedCompany">Remove Pyns Imported</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Remove Pyns by company</p>
              </div>
              <div className="card-action">
                <Link to="removePynsByCompany">Remove Pyns</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Import Pyns from File</p>
              </div>
              <div className="card-action">
                <Link to="importTrypStops">Import Pyns</Link>
              </div>
            </div>
          </div>
        </div>
        
        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Add display field to pyns by company</p>
              </div>
              <div className="card-action">
                <Link to="migratePyns">Go to migrate pyns</Link>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    databases: state.firestore.ordered.databases,
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps))(Pyns);
